import React from 'react';

function FloatingActionButton({ hideOnMobile }) {
  return (
    <div
      className={
        "floating-buttons" +
        (hideOnMobile ? " fab-hide-mobile" : "")
      }
    >
      <a href="https://wa.me/919220424206" className="float-btn whatsapp-btn" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-whatsapp"></i>
      </a>
    </div>
  );
}

export default FloatingActionButton;